<template>
  <div class="common_group">
    <div class="title">
      <img src="@/assets/images/informationIcon.png">
      <span>
        {{ $t('industryReport.zdchqy.name') }}
      </span>
      <div class="buttonBar">
        <el-button @click="addRow" type="primary">
          {{ $t('btn.Add') }}
        </el-button>
      </div>
    </div>
    <commonTable ref="costAscriptionTable" :footer-cost="activityClassificationCode === 'AC_01' ? { label: $t('industryReport.zdchqy.hj'), val: total } : {}" />
  </div>
</template>

<script>
import { newApplicationFormApi } from '../../service';
import commonTable from '@/components/commonTable';
import { TableRow, TableColumns } from '@/utils/tableOptions.js';
export default {
  name: 'AttendMeetings',
  data () {
    return {
      // 表格数据
      tableData: [{
        // 区域编号
        regionId: '', // 区域编号
        // 区域名称
        regionName: '', // 区域名称
        // 建议的会话数
        suggestedSessions: ''
      }],
      // 区域名称列表
      regionNameList: [],
      total: 0
    };
  },
  props: {
    activityClassificationCode: {
      type: String,
      default: ''
    },
    editEchoData: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  components: {
    commonTable
  },
  mounted () {
    // 调用 dataList 方法
    this.dataList();
  },
  watch: {
    activityClassificationCode: {
      handler () {
        this.loadTable();
      }
    },
    editEchoData: {
      immediate: true,
      deep: true,
      handler (val) {
        // 判断val是否存在且val的landingRegionList属性是否存在且长度大于0
        if (val && val.landingRegionList && val.landingRegionList.length > 0) {
          // 将val的landingRegionList赋值给this.tableData
          this.tableData = val.landingRegionList;
        }
      }
    },
    tableData: {
      immediate: true,
      deep: true,
      handler (val) {
        let totalNum = 0;
        val.forEach(item => {
          if (item.suggestedSessions) {
            totalNum += item.suggestedSessions;
          }
        });
        this.total = totalNum;
      }
    }
  },
  methods: {
    /**
    * 获取区域名称列表并加载表格
    */
    dataList () {
      newApplicationFormApi.getRegionName().then(res => {
        if (res.status === '200') {
          this.regionNameList = res.data;
          this.loadTable();
        }
      });
    },
    /**
    * 添加一行到成本归属表格中
    *
    * 在成本归属表格中添加一行，并刷新表格列。
    */
    addRow () {
      this.$refs.costAscriptionTable.insertRow();
      this.$refs.costAscriptionTable.refreshColumn();
    },
    /**
    * 删除按钮点击事件处理函数
    *
    * @param row 要删除的行数据
    */
    deleteBtn (row) {
      this.$refs.costAscriptionTable.removeRow(row);
    },
    loadTable () {
      let tableRow = new TableRow();
      // 区域名称
      tableRow.push(
        new TableColumns()
          ._title(this.$t('industryReport.zdchqy.qymc'))
          ._data('regionId')
          ._cellType('customSelect')
          ._cellData({
            options: this.regionNameList,
            optionProps: {
              label: 'value',
              value: 'key'
            },
            events: {
              change: ({ value, row }) => {
                row.regionName = value !== '' ? this.regionNameList.find(item => item.key === value).value : '';
                row.activityCode = this.$store.state.newApplication.activityCode || this.$route.query.activityCode;
              }
            }
          })
      );
      if (this.activityClassificationCode === 'AC_01') {
        // 建议场次
        tableRow.push(
          new TableColumns()
            ._title(this.$t('industryReport.zdchqy.jycc'))
            ._data('suggestedSessions')
            ._cellType('customDom')
            ._cellData({
              formater: ({ row, column }) => {
                return (
                  <el-input-number
                    v-model={row[column.property]}
                    disabled={row.allowEdit === false && this.$store.state.newApplication.editFlag !== 0}
                    min={1}
                    max={99999999}
                    precision={0}
                    controls={false}
                    class="session-input"
                  />
                );
              }
            })
        );
      }
      // 删除按钮 (btn.Delete) - 对应zh.js中的"删除"
      tableRow.push(
        new TableColumns()
          ._title(this.$t('general.Operation'))
          ._align('center')
          ._cellType('customDom')
          ._cellData({
            formater: ({ row, column }) => {
              return (
                <div>
                  <el-button type="text" onClick={() => {
                    this.deleteBtn(row);
                  }} disabled={this.isDisabledBtn || this.$route.path === '/transferApplication'}> {this.$t('btn.Delete')}
                  </el-button>
                </div>
              );
            }
          })
      );
      let column = tableRow._cols();
      this.$nextTick(() => {
        if (this.$refs.costAscriptionTable) {
          this.$refs.costAscriptionTable.setColumn(column, {
            page: false
          });
          this.$refs.costAscriptionTable.loadStaticTable(this.tableData);
        }
      });
    },
    // 校验
    validateHandler () {
      if (this.tableData.length < 1) {
        this.$message.error(this.$t('newApp.Attribute.pspar'));
        return;
      }
      for (let i = 0; i < this.tableData.length; i++) {
        let item = this.tableData[i];
        if (!item.regionId) {
          this.$message.error(this.$t('industryReport.zdchqytsy.qymc'));
          return;
        }
        if (this.activityClassificationCode === 'AC_01' && !item.suggestedSessions) {
          this.$message.error(this.$t('industryReport.zdchqytsy.jycc'));
          return;
        }
      }
      return true;
    }

  }
};
</script>
<style scoped>
.session-input ::v-deep .el-input .el-input__inner {
  text-align: center !important;
}
</style>
